export enum ButtonLinkIconPosition {
  Right = 'right',
  Left = 'left',
}

export enum ButtonLinkType {
  Primary = 'primary',
  Secondary = 'secondary'
}
